import { call, put } from "redux-saga/effects";
import { batchService } from "../services/batchService";
import { batchConstants } from "../actions/constants/batchConstants";
import { commonConstants } from "../actions/constants/commonConstants";

function* getBatch(action: any): any {
  try {
    const response = yield call(batchService.getBatch, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.getBatchSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getBatchFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getBatchFailure, payload: error });
  }
}

function* createBatch(action: any): any {
  try {
    const response = yield call(batchService.createBatch, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.batchCreateSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: batchConstants.batchCreateFailure, payload: response.errorMessage });
       yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.batchCreateFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* getBatchParams(action: any): any {
  try {
    const response = yield call(batchService.getBatchParams, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.getBatchParamsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getBatchParamsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getBatchParamsFailure, payload: error });
  }
}

function* deleteBatch(action: any): any {
  try {
    const response = yield call(batchService.deleteBatch, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.batchDeleteSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: batchConstants.batchDeleteFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.batchDeleteFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* toggleBatch(action: any): any {
  try {
    const response = yield call(batchService.toggleBatch, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.batchToggleSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: batchConstants.batchToggleFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.batchToggleFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* getAvailableUsers(action: any): any {
  try {
    const response = yield call(batchService.getAvailableUsers, action.payload);  
    if (response.success) {
      yield put({ type: batchConstants.getAvailableUsersSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getAvailableUsersFailure, payload: response.errorMessage });
    } 
  } catch (error) {
    yield put({ type: batchConstants.getAvailableUsersFailure, payload: error });
  }
}

function* viewBatch(action: any): any {
  try {
    const response = yield call(batchService.viewBatch, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.batchViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.batchViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.batchViewFailure, payload: error });
  }
}

function* getAvailableStudents(action: any): any {
  try {
    const response = yield call(batchService.getAvailableStudents, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.getAvailableStudentsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getAvailableStudentsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getAvailableStudentsFailure, payload: error });
  } 
}

function* markAttendance(action: any): any {
  try {
    const response = yield call(batchService.markAttendance, action.payload);
    if (response.success) { 
      yield put({ type: batchConstants.attendanceMarkedSuccess, payload: response.resultObject });
       yield put({ type: commonConstants.showMessageSuccess, payload: response.resultObject.results[0].message });
    } else {
      yield put({ type: batchConstants.attendanceMarkedFailure, payload: response.errorMessage  });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.attendanceMarkedFailure, payload: error });
  }
}

function* getBatchHistory(action: any): any {
  try {
    const response = yield call(batchService.getBatchHistory, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.getBatchHistorySuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getBatchHistoryFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getBatchHistoryFailure, payload: error });
  }
}

function* getOverallStudentAnalytics(action: any): any {
  try {
    const response = yield call(batchService.getOverallStudentAnalytics, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.getOverallStudentAnalyticsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getOverallStudentAnalyticsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getOverallStudentAnalyticsFailure, payload: error });
  }
}

function* getSessionAnalytics(action: any): any {
  try {
    const response = yield call(batchService.getSessionAnalytics, action.payload);  
    if (response.success) {
      yield put({ type: batchConstants.getSessionAnalyticsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getSessionAnalyticsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getSessionAnalyticsFailure, payload: error });
  }
}

function* getAvailableStudentsForBatch(action: any): any {
  try {
    const response = yield call(batchService.getAvailableStudentsForBatch, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.getAvailableStudentsForBatchSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getAvailableStudentsForBatchFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getAvailableStudentsForBatchFailure, payload: error });
  }
}

function* getCalendarDetails(action: any): any {
  try {
    const response = yield call(batchService.getCalendarDetails, action.payload);
    if (response.success) {
      yield put({ type: batchConstants.getCalendarDetailsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: batchConstants.getCalendarDetailsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: batchConstants.getCalendarDetailsFailure, payload: error });
  }
}


export const batchSaga = {
  getBatchParams,
  createBatch,
  markAttendance,
  getAvailableStudents,
  getBatch,
  getAvailableUsers,
  toggleBatch,
  deleteBatch,
  viewBatch,
  getBatchHistory,
  getOverallStudentAnalytics,
  getSessionAnalytics,
  getAvailableStudentsForBatch,
  getCalendarDetails
}
